import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DataTable from '../common/DataTable';
import { getAllUsers } from '../service/authService';
import Input from '../common/Input';
import { IoMdList } from 'react-icons/io';
import { AiFillPlusCircle, AiOutlineEdit } from 'react-icons/ai';
import { RiLockPasswordLine } from 'react-icons/ri';
import AdminNavigation from './AdminNavigation';
import TooltipBox from '../common/TooltipBox';

export default function UserList(props) {
   const [users, setUsers] = useState([]);
   const [items, setItems] = useState([]);
   const [filterValue, setFilterValue] = useState('');
   const pageSize = 20;
   const columns = [
      {
         columnCaption: 'User Id',
         columnKey: 'userId',
      },
      {
         columnCaption: 'Username',
         columnKey: 'username',
      },
      {
         columnCaption: 'Email',
         columnKey: 'email',
      },
      {
         columnCaption: 'Created At',
         columnKey: 'createdAt',
      },
      {
         columnCaption: 'Action',
         content: (item) => (
            <>
               <span className='mr-3'>
                  <Link to={`/User/${item.userId}`}>
                     <TooltipBox text='Edit' component={<AiOutlineEdit style={iconStyleEdit} />} />
                  </Link>
               </span>
               <span>
                  <Link to={`/ChangePassword/${item.userId}`}>
                     <TooltipBox text='Change Password' component={<RiLockPasswordLine style={iconStyleEdit} />} />
                  </Link>
               </span>
            </>
         ),
      },
   ];

   useEffect(() => {
      const fetchUsers = async () => {
         try {
            const response = await getAllUsers();
            const foundUsers = await response.data.data;
            setItems(foundUsers);
            setUsers(foundUsers);
         } catch (error) {}
      };
      fetchUsers();
   }, []);

   const onSearch = (e) => {
      e.preventDefault();
      let value = e.target.value;
      setFilterValue(value);
      let searchItems = [...users];
      let filteredItems = [];
      if (value !== '') {
         filteredItems = searchItems.filter((dataItem) => {
            return (
               dataItem.userId.toString().includes(value) ||
               dataItem.username.includes(value) ||
               dataItem.email.toUpperCase().includes(value.toUpperCase()) ||
               dataItem.createdAt.toUpperCase().includes(value.toUpperCase())
            );
         });
      } else {
         filteredItems = [...users];
      }
      setItems(filteredItems);
   };

   const onAddUser = () => {
      props.history.push('/User');
   };

   const iconStyle = {
      color: '#2c62a9',
      fontSize: 30,
      cursor: 'pointer',
   };

   const iconStyleEdit = {
      color: '#2c62a9',
      fontSize: 15,
      cursor: 'pointer',
   };

   return (
      <div className='container'>
         <div className='row'>
            <div className='col-md-3'>
               <AdminNavigation />
            </div>
            <div className='col-md-9'>
               <h4 className='text-muted ml-1 mb-2 font-italic'>Users</h4>
               <div className='input-group input-group-sm mb-3 mr-sm-2'>
                  <div className='input-group-prepend'>
                     <div className='input-group-text'>
                        <IoMdList />
                     </div>
                  </div>
                  <Input name='searchBox' type='text' className='form-control custom-input' id='searchBox' value={filterValue} placeholder='' onChange={onSearch} />
               </div>
               <div className='mb-1'>
                  <AiFillPlusCircle onClick={onAddUser} style={iconStyle} />
               </div>
               <DataTable items={items} pageSize={pageSize} rowKey={'transactionId'} columns={columns}></DataTable>
            </div>
         </div>
      </div>
   );
}
